/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { Button, Input, CustomDropdown } from '@components';
import PropTypes from 'prop-types';

import { useSettingContext } from '@context/SettingContent';

import sty from '@flow/AuthWrapper/auth.module.scss';

// how many required field
const TOTAL_FIELD = 5;

export default function UserDetail({
  handleFormType,
  handleDataObj,
  dataObj,
  handleBusinessType,
  businessType,
}) {
  const { metaData } = useSettingContext();

  const [isFormPristine, handleFormPristine] = useState(true);

  // for form submission
  const [hasError, handleHasError] = useState({});
  const [fieldCount, handleFieldCount] = useState(0);
  const [canSubmit, handleCanSubmit] = useState(false);

  useEffect(() => {
    if (canSubmit && fieldCount >= TOTAL_FIELD && !Object.keys(hasError).length) {
      handleFormType(3);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canSubmit, fieldCount, hasError]);

  function updateField(name, value) {
    handleCanSubmit(false);
    handleDataObj(state => ({ ...state, [name]: value }));
  }

  function updateSelect(value) {
    handleCanSubmit(false);
    handleBusinessType(value);
  }

  function handleError({ name, value }) {
    const errors = { ...hasError };

    if (!isFormPristine) {
      handleFieldCount(state => (state === TOTAL_FIELD ? TOTAL_FIELD : state + 1));
    }
    if (value) {
      errors[name] = 'error';
    } else {
      delete errors[name];
    }

    handleHasError(errors);
  }

  function handleFormChange() {
    if (isFormPristine) {
      handleFormPristine(false);
    }
    handleCanSubmit(true);
  }

  function getBusiness() {
    return metaData.business_type.reduce(
      (arr, data) =>
        arr.concat({
          label: data.label,
          value: data.id,
        }),
      [],
    );
  }

  return (
    <>
      <div className={sty['two-field']}>
        <Input
          type="text"
          name="name"
          placeholder="Name"
          initialValue={dataObj.name}
          validations={[
            {
              validation: /(.*[A-Za-z])/i,
              message: 'Please enter user name',
            },
          ]}
          pristine={isFormPristine}
          onChange={value => updateField('name', value)}
          onError={errorValue => handleError(errorValue)}
        />
        <Input
          type="text"
          name="surname"
          initialValue={dataObj.surname}
          placeholder="Surname"
          validations={[
            {
              validation: /(.*[A-Za-z])/i,
              message: 'Please enter surname',
            },
          ]}
          pristine={isFormPristine}
          onChange={value => updateField('surname', value)}
          onError={errorValue => handleError(errorValue)}
        />
      </div>
      <Input
        type="password"
        name="password"
        initialValue={dataObj.password}
        placeholder="Choose a Password"
        validations={[
          {
            validation: /^.{1,}/i,
            message: 'Please enter password',
          },
          {
            validation: /^.{8,}/i,
            message: 'Please enter a valid password it must contains 8 characters',
          },
        ]}
        pristine={isFormPristine}
        onChange={value => updateField('password', value)}
        onError={errorValue => handleError(errorValue)}
      />
      <Input
        type="text"
        name="bname"
        initialValue={dataObj.bname}
        placeholder="Business Name"
        validations={[
          {
            validation: /^.{1,}/i,
            message: 'Please enter business name',
          },
        ]}
        pristine={isFormPristine}
        onChange={value => updateField('bname', value)}
        onError={errorValue => handleError(errorValue)}
      />
      <Input
        type="tel"
        name="phone"
        placeholder="Phone no."
        initialValue={dataObj.phone}
        validations={[
          {
            validation: /^.{1,}/i,
            message: 'Please enter phone no.',
          },
          {
            validation: /^.{7,}/i,
            message: 'Invalid Number',
          },
        ]}
        pristine={isFormPristine}
        onChange={value => updateField('phone', value)}
        onError={errorValue => handleError(errorValue)}
      />
      <CustomDropdown
        className="auth-select"
        name="businessType"
        initialValue={businessType}
        pristine={isFormPristine}
        placeholder="Business Type"
        onChange={updateSelect}
        onError={errorValue => handleError(errorValue)}
        getOption={getBusiness()}
      />
      <Button
        className={sty['edit-actions']}
        type={2}
        colorType={2}
        labelBack="Back"
        handleClickBack={() => handleFormType(1)}
        label="Continue"
        handleClickNext={handleFormChange}
      />
    </>
  );
}

UserDetail.propTypes = {
  handleFormType: PropTypes.func,
  handleDataObj: PropTypes.func,
  dataObj: PropTypes.object.isRequired,
  businessType: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  handleBusinessType: PropTypes.func,
};
